import { all, put, select, takeLatest } from 'redux-saga/effects';
import { PharmaciesActionTypes } from './pharmacies-actions';
import { AlertActionType } from '@store/alert/alert-action';
import { AuthActionTypes } from '@store/auth/auth-actions';
import uploadPharmacyFileApi from '@api/pharmacies/upload-pharmacy-file';
import pharmacyStoreDataApi from '@api/pharmacies/store-pharmacy';
import insuranceListApi from '@api/pharmacies/insurance-list';
import { pharmacyStore } from './pharmacies.store';
import { authStore } from '../auth/auth-store';
import { setNewAddressWatcher } from '@store/client/contact-information/contact-information-middleware';
import routes from '@routes';
import checkDrug from '@api/pharmacies/check-drug';
import { homeStore } from '@store/home-screen/home-store';
import getParseRoute from '@utils/helpers/parse-route';
import removeFromLocal from '@utils/storage/remove-from-local';
import singleSettingApi from '@api/settings/single-setting';

function* storePharmacyUploadDataWatcher() {
  try {
    const { pharmacyFile, pharmacyText, contactInfo: { addressesList }, clientSuggestedType, clientSuggestedTime, clientSuggestedRange, auth: { firstName, lastName, nationalId, sex }, hashedPharmacyId } = yield select(pharmacyStore);
    const { navigation } = yield select(homeStore);

    if (!addressesList.length) {
      yield setNewAddressWatcher();
    }

    const uploadFileResponse: { data: any } = yield uploadPharmacyFileApi({ file: pharmacyFile, cache: 'no-cache' });
    const { contactInfo: { selectedAddressId } } = yield select(pharmacyStore);
    if (uploadFileResponse) {
      const PrescriptionResponse: { data: { order_reference_id_affix: string } } = yield pharmacyStoreDataApi({
        clientContactId: selectedAddressId,
        clientSuggestedType: clientSuggestedType,
        clientSuggestedTime: clientSuggestedTime,
        clientSuggestedRange: clientSuggestedRange,
        file: {
          '1': uploadFileResponse,
        },
        gender: sex,
        applicantName: firstName,
        applicantLastName: lastName,
        applicantCode: nationalId,
        description: pharmacyText,
        contributors: { 1: `${firstName} ${lastName}` },
        hashedPharmacyId: hashedPharmacyId,
        cache: 'no-cache',
      });
      yield put({
        type: AlertActionType.SHOW_ALERT,
        text: 'اطلاعات نسخه داروخانه شما با موفقیت ذخیره شد.',
        severity: 'success',
      });
      // ReactGA.ga('send', 'event', 'Rx', 'preorder', 'register a rx preorder');
      // @ts-ignore
      if (window && window.gtag) {
        // @ts-ignore
        window.gtag('event', 'conversion', {
          'send_to': 'AW-631414638/U1_ECJjEtoMaEO6-iq0C',
        });
      }
      //@ts-ignore
      if (window && window._paq) {
        // @ts-ignore
        window._paq.push(['trackGoal', 1, 1300]);
      }
      if (window.location.pathname.startsWith('/mobile')) {
        yield navigation.replace(`/mobile${getParseRoute({ pathname: routes['route.client.pharmacy-order-details'], query: { id: PrescriptionResponse?.data?.order_reference_id_affix } })}`);
      } else {
        yield navigation.replace(getParseRoute({ pathname: routes['route.client.pharmacy-order-details'], query: { id: PrescriptionResponse?.data?.order_reference_id_affix } }));
      }
    } else {
      yield put({
        type: AlertActionType.SHOW_ALERT,
        text: 'متاسفانه در حال حاضر امکان ثبت سفارش دارو با نسخه در دسترس نیست، برای اطلاعات بیشتر با پشتیبانی تماس بگیرید',
        severity: 'danger',
      });
    }
  } catch (error: any) {
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: error?.message || 'متاسفانه در حال حاضر امکان ثبت سفارش دارو با نسخه در دسترس نیست، لطفا بعدا تلاش نمایید.',
      severity: 'danger',
    });
  }
  yield put({
    type: PharmaciesActionTypes.SET_STORE_LOADING,
  });
}

function* storePharmacyOtcDataWatcher() {
  try {
    const { recipients, otcList, contactInfo: { addressesList }, clientSuggestedType, clientSuggestedTime, clientSuggestedRange, auth: { firstName, lastName, nationalId, sex }, hashedPharmacyId } = yield select(pharmacyStore);
    const { navigation } = yield select(homeStore);

    if (!addressesList.length) {
      yield setNewAddressWatcher();
    }

    const { contactInfo: { selectedAddressId } } = yield select(pharmacyStore);
    const OtcResponse: { data: { order_reference_id_affix: string } } = yield pharmacyStoreDataApi({
      clientContactId: selectedAddressId,
      clientSuggestedType: clientSuggestedType,
      clientSuggestedTime: clientSuggestedTime,
      clientSuggestedRange: clientSuggestedRange,
      gender: sex,
      applicantName: firstName,
      applicantLastName: lastName,
      applicantCode: nationalId,
      contributors: recipients,
      // list: JSON.stringify(otcList),
      list: otcList,
      hashedPharmacyId: hashedPharmacyId,
      cache: 'no-cache',
    });
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: 'اطلاعات نسخه داروخانه شما با موفقیت ذخیره شد.',
      severity: 'success',
    });
    removeFromLocal('otc_list');
    // ReactGA.ga('send', 'event', 'Rx', 'preorder', 'register a rx preorder');
    // @ts-ignore
    if (window && window.gtag) {
      // @ts-ignore
      window.gtag('event', 'conversion', {
        'send_to': 'AW-631414638/U1_ECJjEtoMaEO6-iq0C',
      });
    }
    //@ts-ignore
    if (window && window._paq) {
      // @ts-ignore
      window._paq.push(['trackGoal', 1, 1300]);
    }
    if (window.location.pathname.startsWith('/mobile')) {
      yield navigation.replace(getParseRoute({ pathname: `/mobile${routes['route.client.pharmacy-order-details']}`, query: { id: OtcResponse?.data?.order_reference_id_affix } }));
    } else {
      yield navigation.replace(getParseRoute({ pathname: routes['route.client.pharmacy-order-details'], query: { id: OtcResponse?.data?.order_reference_id_affix } }));
    }
  } catch (error: any) {
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: error?.message || 'متاسفانه در حال حاضر امکان ثبت سفارش دارو بدون نسخه در دسترس نیست، لطفا بعدا تلاش نمایید.',
      severity: 'danger',
    });
  }
  yield put({
    type: PharmaciesActionTypes.SET_STORE_LOADING,
  });
}

function* nextStepValidationWatcher() {
  try {
    const { isLoggedIn } = yield select(authStore);
    const { navigation } = yield select(homeStore);

    yield put({ type: PharmaciesActionTypes.CHECK_CARD_VALIDATION });
    const { otcCardFlag, otcList } = yield select(pharmacyStore);

    if (isLoggedIn) {
      if (otcCardFlag) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
        yield put({
          type: AlertActionType.SHOW_ALERT,
          text: 'اطلاعات مورد نیاز را وارد کنید',
          severity: 'danger',
        });
      } else {
        const data = otcList.filter((item: any) => !item.isLocked);
        if (data && data.length > 0) {
          yield put({
            type: PharmaciesActionTypes.SET_PHARMACY_OTC_FOR_VALIDATION,
            data: {
              id: data[0]?.key,
            },
          });
          yield handleCardValidationWatcher();
        }
      }
      yield put({
        type: PharmaciesActionTypes.DISABLE_COMPLETE_ORDER,
      });
      if (window.location.pathname.startsWith('/mobile')) {
        yield navigation.push(`/mobile${routes['route.pharmacies.checkout-otc']}`);
      } else {
        yield navigation.push(routes['route.pharmacies.checkout-otc']);
      }
    } else {
      yield put({
        type: AuthActionTypes.SET_LOGIN_MODAL,
        data: {
          loginModal: true,
          redirectRoute: undefined,
          callBackTypeId: 'pharmacy',
        },
      });
    }
  } catch (error) {
  }
}

function* uploadDrugImageWatcher() {
  try {
    const { pharmacyEditedImage } = yield select(pharmacyStore);

    const uploadFileResponse: { data: any } = yield uploadPharmacyFileApi({ file: pharmacyEditedImage, cache: 'no-cache' });
    if (uploadFileResponse) {
      yield put({
        type: PharmaciesActionTypes.INSERT_DRUG_IMAGE,
        data: {
          pharmacyEditedImage: uploadFileResponse,
        },
      });
    } else {
      yield put({ type: PharmaciesActionTypes.SET_IMAGE_INITIAL });
      yield put({
        type: AlertActionType.SHOW_ALERT,
        text: 'متاسفانه در حال حاضر امکان آپلود عکس در دسترس نیست، برای اطلاعات بیشتر با پشتیبانی تماس بگیرید',
        severity: 'danger',
      });
    }
  } catch (error: any) {
    yield put({ type: PharmaciesActionTypes.SET_IMAGE_INITIAL });
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: error?.message || 'متاسفانه در حال حاضر امکان آپلود عکس در دسترس نیست، برای اطلاعات بیشتر با پشتیبانی تماس بگیرید.',
      severity: 'danger',
    });
  }
}

function* setNewDrugValidationWatcher() {
  yield put({ type: PharmaciesActionTypes.CHECK_CARD_VALIDATION });
  const { otcCardFlag } = yield select(pharmacyStore);

  if (!otcCardFlag) {
    yield put({ type: PharmaciesActionTypes.SET_NEW_DRUG });
  } else {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: 'اطلاعات مورد نیاز را وارد کنید',
      severity: 'danger',
    });
  }
}

function* handleCardValidationWatcher() {
  try {
    yield put({ type: PharmaciesActionTypes.SET_CHECK_DRUG_LOADING, data: { loading: true } });
    yield put({ type: PharmaciesActionTypes.CHECK_CARD_VALIDATION });
    const { otcCardFlag } = yield select(pharmacyStore);

    if (!otcCardFlag) {
      // yield checkDrug({
      //   name: otcValidationInfo?.name,
      //   unit: otcValidationInfo?.unit,
      //   quantity: otcValidationInfo?.quantity,
      //   cache: 'no-cache',
      // });

      yield put({
        type: PharmaciesActionTypes.SET_LOCK_CARD,
        data: {
          isLocked: true,
        },
      });
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      yield put({
        type: AlertActionType.SHOW_ALERT,
        text: 'اطلاعات مورد نیاز را وارد کنید',
        severity: 'danger',
      });
      yield put({ type: PharmaciesActionTypes.SET_LOCK_CARD });
    }
  } catch (error: any) {
    yield put({ type: PharmaciesActionTypes.SET_LOCK_CARD });
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: error?.message || 'متاسفانه در حال حاضر امکان آپلود عکس در دسترس نیست، برای اطلاعات بیشتر با پشتیبانی تماس بگیرید.',
      severity: 'danger',
    });
    throw (error);
  }
}

function* handleLockCardWatcher() {
  try {
    const { isLoggedIn } = yield select(authStore);
    if (isLoggedIn) {
      yield handleCardValidationWatcher();
    } else {
      yield put({
        type: AuthActionTypes.SET_LOGIN_MODAL,
        data: {
          loginModal: true,
          redirectRoute: undefined,
          callBackTypeId: 'checkLockCard',
        },
      });
    }
  } catch (error) {
  }
}

function* pharmacyDataValidationWatcher() {
  const { isLoggedIn } = yield select(authStore);
  const { validationType } = yield select(pharmacyStore);
  if (!isLoggedIn) {
    yield put({
      type: AuthActionTypes.SET_LOGIN_MODAL,
      data: {
        loginModal: true,
        redirectRoute: undefined,
        callBackTypeId: 'pharmacy',
      },
    });
  } else {
    if (validationType === 'otc') {
      yield otcDataValidationWatcher();
    } else if (validationType === 'prescription') {
      yield prescriptionDataValidationWatcher();
    } else {
      yield put({ type: PharmaciesActionTypes.CHECK_ELECTRONIC_VALIDATION });
    }
  }
}

function* otcDataValidationWatcher() {
  try {
    yield put({
      type: PharmaciesActionTypes.SET_PHARMACY_LOADING,
      data: {
        loading: true,
      },
    });
    yield put({ type: PharmaciesActionTypes.CHECK_CARD_VALIDATION });
    const { otcCardFlag, otcList } = yield select(pharmacyStore);
    const { navigation } = yield select(homeStore);

    if (!otcCardFlag) {
      yield checkDrug({
        data: otcList,
        cache: 'no-cache',
      });
      yield put({
        type: PharmaciesActionTypes.SET_PHARMACY_LOADING,
        data: {
          loading: false,
        },
      });
      if (window.location.pathname.startsWith('/mobile')) {
        yield navigation.push(`/mobile${routes['route.pharmacies.checkout-otc']}`);
      } else {
        yield navigation.push(routes['route.pharmacies.checkout-otc']);
      }
    } else {
      yield put({
        type: PharmaciesActionTypes.SET_PHARMACY_LOADING,
        data: {
          loading: false,
        },
      });
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      yield put({
        type: AlertActionType.SHOW_ALERT,
        text: 'اطلاعات مورد نیاز را وارد کنید',
        severity: 'danger',
      });
    }
  } catch (e: any) {
    yield put({
      type: PharmaciesActionTypes.SET_PHARMACY_LOADING,
      data: {
        loading: false,
      },
    });
    let errorMessage = '';
    for (const errorMessagesKey in e.message) {
      yield errorMessage += `${e.message[errorMessagesKey]}\n`;
    }
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: errorMessage,
      severity: 'danger',
    });
  }
}

function* prescriptionDataValidationWatcher() {
  const { pharmacyFile } = yield select(pharmacyStore);
  const { navigation } = yield select(homeStore);

  if (pharmacyFile) {
    if (window.location.pathname.startsWith('/mobile')) {
      yield navigation.push(`/mobile${routes['route.pharmacies.checkout-upload']}`);
    } else {
      yield navigation.push(routes['route.pharmacies.checkout-upload']);
    }
  } else {
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: 'لطفا فایل خود را آپلود کنید',
      severity: 'danger',
    });
  }
}

function* getInsuranceListWatcher() {
  try {
    const InsuranceListResponse: { data: any } = yield insuranceListApi({ cache: 'no-cache' });
    yield put({
      type: PharmaciesActionTypes.SET_INSURANCE_LIST,
      data: InsuranceListResponse?.data,
    });
  } catch (error: any) {
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: error?.message || 'متاسفانه در حال حاضر امکان ثبت سفارش نسخه در دسترس نیست، لطفا بعدا تلاش نمایید.',
      severity: 'danger',
    });
  }
}

function* checkElectronicValidationWatcher() {
  const { electronicPrescriptionFlag, electronicPrescription } = yield select(pharmacyStore);
  const { navigation } = yield select(homeStore);

  if (!electronicPrescriptionFlag) {
    if (window.location.pathname.startsWith('/mobile')) {
      yield navigation.push(`/mobile${routes['route.pharmacies.checkout-electronic-prescription']}`);
    } else {
      yield navigation.push(routes['route.pharmacies.checkout-electronic-prescription']);
    }
  } else {
    if (electronicPrescription?.nationalFlag && electronicPrescription?.national_code !== '') {
      yield put({
        type: AlertActionType.SHOW_ALERT,
        text: 'کد ملی اشتباه است',
        severity: 'danger',
      });
    } else {
      yield put({
        type: AlertActionType.SHOW_ALERT,
        text: 'لطفا فیلد های مشخص شده را تکمیل کنید',
        severity: 'danger',
      });
    }
  }
}

function* storePharmacyElectronicDataWatcher() {
  try {
    const { recipients, electronicPrescription, contactInfo: { addressesList }, clientSuggestedType, clientSuggestedTime, clientSuggestedRange, auth: { firstName, lastName, nationalId, sex }, hashedPharmacyId } = yield select(pharmacyStore);
    const { navigation } = yield select(homeStore);

    if (!addressesList.length) {
      yield setNewAddressWatcher();
    }

    const { contactInfo: { selectedAddressId } } = yield select(pharmacyStore);
    const OtcResponse: { data: { order_reference_id_affix: string } } = yield pharmacyStoreDataApi({
      clientContactId: selectedAddressId,
      clientSuggestedType: clientSuggestedType,
      clientSuggestedTime: clientSuggestedTime,
      clientSuggestedRange: clientSuggestedRange,
      gender: sex,
      applicantName: firstName,
      applicantLastName: lastName,
      applicantCode: nationalId,
      contributors: recipients,
      electronicPrescription: electronicPrescription,
      hashedPharmacyId: hashedPharmacyId,
      cache: 'no-cache',
    });
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: 'اطلاعات نسخه داروخانه شما با موفقیت ذخیره شد.',
      severity: 'success',
    });
    // ReactGA.ga('send', 'event', 'Rx', 'preorder', 'register a rx preorder');
    // @ts-ignore
    if (window && window.gtag) {
      // @ts-ignore
      window.gtag('event', 'conversion', {
        'send_to': 'AW-631414638/U1_ECJjEtoMaEO6-iq0C',
      });
    }
    //@ts-ignore
    if (window && window._paq) {
      // @ts-ignore
      window._paq.push(['trackGoal', 1, 1300]);
    }
    if (window.location.pathname.startsWith('/mobile')) {
      yield navigation.replace(getParseRoute({ pathname: `/mobile${routes['route.client.pharmacy-order-details']}`, query: { id: OtcResponse?.data?.order_reference_id_affix } }));
    } else {
      yield navigation.replace(getParseRoute({ pathname: routes['route.client.pharmacy-order-details'], query: { id: OtcResponse?.data?.order_reference_id_affix } }));
    }
  } catch (error: any) {
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: error?.message || 'متاسفانه در حال حاضر امکان ثبت سفارش دارو بدون نسخه در دسترس نیست، لطفا بعدا تلاش نمایید.',
      severity: 'danger',
    });
  }
  yield put({
    type: PharmaciesActionTypes.SET_STORE_LOADING,
  });
}

function* getPharmacyBannerWatcher() {
  try {
    const bannerResponse: { data: {key: string, value: string} } = yield singleSettingApi({ key: 'courier_free_price_in_toman', cache: 'no-cache' });
    yield put({
      type: PharmaciesActionTypes.SET_PHARMACY_BANNER,
      data: {
        bannerPrice: bannerResponse?.data?.value,
      },
    });
  } catch (error: any) {
    yield put({
      type: PharmaciesActionTypes.SET_PHARMACY_BANNER,
      data: {
        bannerPrice: 0,
      },
    });
  }
}

function* pharmacyMiddleware() {
  yield all([
    takeLatest(PharmaciesActionTypes.STORE_UPLOAD_PHARMACY_DATA, storePharmacyUploadDataWatcher),
    takeLatest(PharmaciesActionTypes.STORE_OTC_PHARMACY_DATA, storePharmacyOtcDataWatcher),
    takeLatest(PharmaciesActionTypes.NEXT_STEP_VALIDATION, nextStepValidationWatcher),
    takeLatest(PharmaciesActionTypes.SET_EDIT_IMAGE_FILE, uploadDrugImageWatcher),
    takeLatest(PharmaciesActionTypes.SET_NEW_DRUG_VALIDATION, setNewDrugValidationWatcher),
    takeLatest(PharmaciesActionTypes.HANDLE_LOCK_CARD, handleLockCardWatcher),
    takeLatest(PharmaciesActionTypes.HANDLE_CARD_VALIDATION, handleLockCardWatcher),
    takeLatest(PharmaciesActionTypes.PHARMACY_DATA_VALIDATION, pharmacyDataValidationWatcher),
    takeLatest(PharmaciesActionTypes.GET_INSURANCE_LIST, getInsuranceListWatcher),
    takeLatest(PharmaciesActionTypes.CHECK_ELECTRONIC_VALIDATION, checkElectronicValidationWatcher),
    takeLatest(PharmaciesActionTypes.STORE_ELECTRONIC_PHARMACY_DATA, storePharmacyElectronicDataWatcher),
    takeLatest(PharmaciesActionTypes.GET_PHARMACY_BANNER, getPharmacyBannerWatcher),
  ]);
}

export default pharmacyMiddleware;
